import { render, staticRenderFns } from "./AccountBanksTable.vue?vue&type=template&id=6e8ad5d6&scoped=true"
import script from "./AccountBanksTable.vue?vue&type=script&lang=js"
export * from "./AccountBanksTable.vue?vue&type=script&lang=js"
import style0 from "./AccountBanksTable.vue?vue&type=style&index=0&id=6e8ad5d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ad5d6",
  null
  
)

export default component.exports